import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { UmRoleViewModalComponent } from './um-role-view-modal/um-role-view-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-um-role',
  templateUrl: './um-role.component.html',
  styleUrls: ['./um-role.component.scss']
})
export class UmRoleComponent implements OnInit {
  columnDefs;
  operations;
  collapesedOrNot: boolean;
  gridApi: GridApi;
  selectedRow;
  rowData;
  StatusList: any[] = [];
  advanceSearch;
  tempoperations;
  tempoperations2;
  isSettings: boolean = false;
  roleForm: UntypedFormGroup;
  constructor(
    public route: ActivatedRoute,
    private summaryService: UmSummaryService,
    private modalService: NgbModal,
    private commonservice: CommonService
  ) {
  }

  ngOnInit() {
    this.StatusList.push({
      label: "All",
      value: "101"
    })
    this.StatusList.push({
      label: "Active",
      value: "1"
    })
    this.StatusList.push({
      label: "Inactive",
      value: "0"
    })

    this.collapesedOrNot = false;

    this.columnDefs = [
      {
        "field": "Role_Name",
        "headerName": "User Role",

      },
      {
        "field": "Status",
        "headerName": "Status"
      }
    ];

    this.advanceSearch = {
      "fields": [
        {
          "label": "Name",
          "field": "NAME",
          "type": "text"
        }
      ]
    }
    this.roleForm = new UntypedFormGroup({
      CODE: new UntypedFormControl("")
    });

    this.setSummary();
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(RecordData: any) {
    const Modalref = this.modalService.open(UmRoleViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    Modalref.componentInstance.Content = {
      heading: 'Edit',
      content: { id: RecordData.data['ID'] }
    };
  }


  view(RecordData: any) {
    let modalRef = this['self'].modalService.open(UmRoleViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true

    });
    modalRef.componentInstance.Content = {
      heading: 'View',
      content: { id: RecordData['Role_ID'] }
    }
    modalRef.result.then((result) => {
      this['self'].setSummary();
    });

  }


  add() {
    let modalRef = this['self'].modalService.open(UmRoleViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animated: true
    });
   
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: null
    }
    modalRef.result.then((result) => {
      this['self'].setSummary();
    });
  }

  edit(RecordData: any) {
    let modalRef = this['self'].modalService.open(UmRoleViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true

    });
   
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: RecordData['Role_ID'] }
    }
    modalRef.result.then((result) => {
      this['self'].setSummary();
    });
  }

  delete(RecordData: any) {
    const id = RecordData['Role_ID'];
    const Name = RecordData['Role_Name'];
    const modalRef = this["self"].modalService.open(DeleteBoxComponent,
      {backdrop: false})

    modalRef.componentInstance.Content = {
      heading: 'Delete',
      custommessage: 'Are you sure you want to delete the User Role '+ "'" + Name + "'" + ' ?',
      ProceedButtonName: "Delete",
      TerminateButtonName: "Cancel"
    }

    modalRef.result.then(result => {
      if (result != 'cancelclick') {
        this['self'].summaryService.deleteRoleSummary(id).subscribe(result => {
          if (result.Status === 0) {
            this['self'].commonservice.SuccessBanner("User Role '" + Name + "' deleted successfully");
            this['self'].setSummary();
          }
          else {
            this['self'].commonservice.ValidationBanner(result.Message);
          }
        });
      }
    });


  }


  setSummary() {
    this.SearchClear();
    this.summaryService.getRole("-1").subscribe(summary => {
      this.rowData = this.setOperations(summary);

    });
  }

  setDef(parmoperations: any): any {

    this.operations = parmoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    return this.operations;
  }

  setSearchSummary(formData) {
    if (formData["RECORD_STATE"] == null || formData["RECORD_STATE"] == undefined) {
      formData["RECORD_STATE"] = "101";
    }
    this.summaryService.getRoleSearchSummary(formData).subscribe(summary => {

      this.rowData = this.setOperations(summary);
    });
  }

  setOperations(RawData: any): any {
    this.tempoperations = [];
    this.tempoperations2 = [];
    if (this.commonservice.getScreenPermission("103", "V")) {
      this.isSettings = true;
      this.tempoperations.push({
        "name": "View",
        "id": "view"
      });
      this.tempoperations2.push({
        "name": "View",
        "id": "view"
      });
    }
    if (this.commonservice.getScreenPermission("103", "E")) {
      this.isSettings = true;
      this.tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });
    }
    if (this.commonservice.getScreenPermission("103", "D")) {
      this.isSettings = true;
      this.tempoperations.push({
        "name": "Delete",
        "id": "delete"
      });
    }
    if (this.commonservice.getScreenPermission("103", "N")) {
      this.tempoperations.push({
        "name": "Add User Role",
        "id": "add"
      });
      this.tempoperations2.push({
        "name": "Add User Role",
        "id": "add"
      });
    }
    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });


    RawData.forEach(element => {
      if (element.Role_Code == "ROLE-01") {
        element["Operations"] = this.setDef(this.tempoperations2);
      }
      else {
        element["Operations"] = this.setDef(this.tempoperations);
      }
    });
    return RawData;
  }
  //// Advace search Functions
  SearchClear() {
    this.roleForm = new UntypedFormGroup({
      Role_Name: new UntypedFormControl(""),
      RECORD_STATE: new UntypedFormControl("101")
    });
  }

  AdvanceSearch() {
    //  debugger
    var formData = this.roleForm.value;
    this.setSearchSummary(formData);
  }
}
